import React, { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import Avatar from "@material-ui/core/Avatar"
import Button from "@material-ui/core/Button"
import CssBaseline from "@material-ui/core/CssBaseline"
import TextField from "@material-ui/core/TextField"
import Link from "@material-ui/core/Link"
import Box from "@material-ui/core/Box"
import LockOutlinedIcon from "@material-ui/icons/LockOutlined"
import Typography from "@material-ui/core/Typography"
import { makeStyles } from "@material-ui/core/styles"
import Container from "@material-ui/core/Container"
import Alert from "@material-ui/lab/Alert"
import Visibility from "@material-ui/icons/Visibility"
import VisibilityOff from "@material-ui/icons/VisibilityOff"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"
import InputAdornment from "@material-ui/core/InputAdornment"
import Backdrop from "@material-ui/core/Backdrop"
import CircularProgress from "@material-ui/core/CircularProgress"

import JwtDecode from "jwt-decode"
import Cookies from "universal-cookie"
import axios from "axios"
import { checkTokenExpirationMiddleware } from "../../middlewares/users-auth.middleware"

const Copyright = () => {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="http://www.evapharma.com/">
        EVA Pharma
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  )
}

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  }
}))

const Login = () => {
  const classes = useStyles()
  let history = useHistory()
  const [user, setUser] = useState(checkTokenExpirationMiddleware())
  const [loading, setLoading] = useState(null)
  const [loginError, setLoginError] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  useEffect(() => {
    if (user != null) history.push("/home")
  }, [user])

  const authenticateUser = event => {
    event.preventDefault()
    setLoading(true)
    // Basic Validation
    // Validation for email required
    if (document.querySelector("#username").value.trim() === "" || document.querySelector("#password").value.trim() === "") setLoginError(true)
    else {
      let user = {
        UserName: document.querySelector("#username").value.trim(),
        Password: document.querySelector("#password").value
      }
      let headers = {
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8",
        "Content-Encoding": "gzip"
      }
      axios
        .post(`${process.env.REACT_APP_API}/api/login`, JSON.stringify(user), { headers: headers })
        .then(res => {
          if (res.data.token === null) {
            setLoginError(true)
            setLoading(null)
            return
          }
          // Decode the token
          let tkDecoded = JwtDecode(res.data.token)

          // Get user object
          let user = {
            UserId: parseInt(tkDecoded.UserID),
            FullName: tkDecoded.FullName,
            TourismCompanyID: parseInt(tkDecoded.TourismCompanyID),
            CompanyName: tkDecoded.CompanyName
          }

          // Make auth cookie
          let cookies = new Cookies()
          cookies.set("evarsv_aut10", res.data.token, [
            {
              path: "/",
              expires: JwtDecode(res.data.token).exp,
              secure: true,
              httpOnly: true
            }
          ])

          // Change state
          setUser(user)
        })
        .catch(err => {
          setLoading(null)
          setLoginError(true)
        })
    }
  }

  return (
    <>
      {loading ? (
        <Backdrop className="backdrop" open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : null}
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Log in
          </Typography>
          <form className={classes.form} onSubmit={authenticateUser}>
            <TextField variant="outlined" margin="normal" required fullWidth id="username" label="Username" name="username" autoComplete="username" autoFocus />
            <FormControl variant="outlined" required fullWidth>
              <InputLabel htmlFor="password">Password</InputLabel>
              <OutlinedInput
                margin="none"
                name="password"
                label="Password"
                type={showPassword ? "text" : "password"}
                id="password"
                autoComplete="current-password"
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)} onMouseDown={event => event.preventDefault()} edge="end">
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            {loginError ? <Alert severity="error"> Wrong Username or Password!</Alert> : null}
            <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit}>
              Log In
            </Button>
          </form>
        </div>
        <Box mt={8}>
          <Copyright />
        </Box>
      </Container>
    </>
  )
}

export default Login
